import { useMediaQuery, useTheme } from "@mui/material";
import { HiOutlineViewGrid } from "react-icons/hi";
import { MdGroups, MdOutlineRocketLaunch } from "react-icons/md";
import { IoOptions } from "react-icons/io5";
import DiamondIcon from "@mui/icons-material/Diamond";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { LuHeadphones } from "react-icons/lu";
import { useContext } from "react";
import { Context } from "../../../../Store/Store";
import { mixpanelEvent } from "../../../../Utils/mixpanelUtils";

// This is where we can control the menu item for both
// desktop and mobile
const sideBarRenderer = (user, premiumUser) => ({
  top: [
    {
      id: 0,
      title: "Sales Insights",
      link: "/Home",
      Icon: HiOutlineViewGrid,
      isShow: premiumUser,
    },
    {
      id: 1,
      title: "Prospect Feed",
      link: "/NurtureProspects",
      Icon: MdGroups,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Monitor",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: premiumUser,
    },
    {
      id: 2,
      title: "Customize AI",
      link: "/CustomizeAI",
      Icon: IoOptions,
      isShow: premiumUser,
    },
    {
      id: 3,
      title: "Community",
      link: "/PodCommunity",
      Icon: MdOutlineRocketLaunch,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Share",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: user?.data?.group === "Member" || user?.data?.podAccess === true,
    },
    {
      id: 4,
      title: "Refer and Earn",
      link: "/ReferAndEarn",
      Icon: CardGiftcardIcon,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Refer and Earn",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: true,
    },
    {
      id: 5,
      title: "Upgrade to Pro",
      link: "/Billing",
      Icon: DiamondIcon,
      onClick: () => {
        mixpanelEvent("upgrade_to_pro_clicked", {
          button_text: "Upgrade to Pro",
          page_section: "Sidebar",
          screen_name: "Engagment community and software",
        });
      },
      isShow: false,
      desktopProps: {
        sx: {
          mt: "1rem",
          backgroundColor: "#FF9D00",
          border: "1px solid #B47B1F",
          color: "#FFF",
          "&:hover": {
            borderRadius: "8px",
          },
          "& .MuiListItemIcon-root": {
            color: "white",
          },
        },
      },
      mobileProps: {
        sx: {
          background: "#FF9D00",
          border: "1px solid #B47B1F",
          color: "#FFF",
          mt: 3,
          "& .MuiListItemIcon-root": { color: "#FFF" },
        },
      },
    },
  ],
  bottom: [
    {
      id: 5,
      title: "Help Centre",
      Icon: LuHeadphones,
      onClick: () => {
        mixpanelEvent("support_link_clicked", {
          link_name: "Help & Strategy Hub",
          link_section: "sidebar",
          screen_name: "Engagment community and software",
        });
        window.open(
          "https://engage-ai.hiverkb.com/",
          "_blank",
          "noopener noreferrer"
        );
      },
      isShow: true,
      mobileProps: {
        as: "a",
        href: "https://engage-ai.hiverkb.com/",
        target: "_blank",
        referrerPolicy: "nooopener noreferrer",
        disableRipple: true,
        sx: { textDecoration: "none", color: "#839BB0" },
      },
    },
  ],
});

export const SideBarContainer = (props) => {
  const { children } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const context = useContext(Context);
  const state = context[0];
  const premiumUser =
    state.user?.data?.group === "Premium" ||
    state.user?.data?.group === "Growth Plan" ||
    state.user?.data?.group === "Member" ||
    state.user?.data?.group === "Starter" ||
    state.user?.data?.group === "Trial";
  
  const sideBarContent = sideBarRenderer(state.user, premiumUser);

  return children({ isMobile, sideBarContent });
};
